import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=b7a2dee6&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=ts&"
export * from "./ArticleList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=b7a2dee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a2dee6",
  null
  
)

export default component.exports